import { render, staticRenderFns } from "./QuotationRiskItemCafezal.vue?vue&type=template&id=76d6bc05&scoped=true"
import script from "./QuotationRiskItemCafezal.vue?vue&type=script&lang=js"
export * from "./QuotationRiskItemCafezal.vue?vue&type=script&lang=js"
import style0 from "./QuotationRiskItemCafezal.vue?vue&type=style&index=0&id=76d6bc05&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d6bc05",
  null
  
)

export default component.exports